import {
  AiOutlineCloseCircle,
  PiWarningCircleBold,
} from "../../Context/exportIcons";
import { useContextHook } from "../../Context/ContextOPen";
import { Col } from "../../Tools/Grid-system";
import ButtonMain from "../Buttons/ButtonMain";
import { content } from "../../Context/translate";
const MessagesError = () => {
  const { listError, setListError } = useContextHook();
  return (
    <div>
      {listError.length > 0 && (
        <>
          <div
            onClick={() => {
              setListError([]);
            }}
            className="fixed top-0 left-0 w-full h-full z-[63] bg-black/30"
          />
          <Col
            md={5}
            sm={11}
            className="z-[64] bg-Secondary  rounded-lg fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          >
            <div>
              <div className="flex justify-between items-center text-white py-3 px-2 border-b">
                <div>
                  <AiOutlineCloseCircle
                    size={25}
                    className="hover:text-Main cursor-pointer hover:scale-105 transition-all"
                    onClick={() => {
                      setListError([]);
                    }}
                  />
                </div>
                <div className="text-white font-bold text-lg">
                  {content.Warning}
                </div>
                <div>
                  <PiWarningCircleBold
                    size={25}
                    className="hover:text-Main cursor-pointer hover:scale-105 transition-all"
                  />
                </div>
              </div>
              <div>
                <ul className="text-white py-2 px-3 text-lg font-semibold">
                  {listError?.map((e, i) => (
                    <li key={i} className="flex items-center py-1">
                      <div className="w-2 h-2 rounded-full bg-white mx-2"></div>
                      <div className="">{e}</div>
                    </li>
                  ))}
                </ul>
                <ButtonMain
                  onClick={() => {
                    setListError([]);
                  }}
                  title={content.ok}
                  className="mx-3 my-2 bg-white !text-Secondary !text-lg !font-bold hover:!bg-Main cursor-pointer hover:!text-white"
                />
              </div>
            </div>
          </Col>
        </>
      )}
    </div>
  );
};

export default MessagesError;
